export const REFRESH_TEMPLATES = 'REFRESH_TEMPLATES';
export const CLEAR_TEMPLATES_FILTERS = 'CLEAR_TEMPLATES_FILTERS';
export const FILTER_TEMPLATES = 'FILTER_TEMPLATES';
